import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cell"]

  saveCell(event) {
    const input = event.target
    const url = input.dataset.cellUrl
    const value = input.value

    if (!url) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ intern_schedule_cell: { content: value } })
    }).then(response => {
      if (response.ok) {
        input.style.borderColor = "#D1FAE5"
        setTimeout(() => { input.style.borderColor = "transparent" }, 1000)
      } else {
        input.style.borderColor = "#FCA5A5"
        setTimeout(() => { input.style.borderColor = "transparent" }, 2000)
      }
    }).catch(() => {
      input.style.borderColor = "#FCA5A5"
      setTimeout(() => { input.style.borderColor = "transparent" }, 2000)
    })
  }
}
